import React from 'react';
import { browserHistory, withRouter } from 'react-router';
import queryString from 'query-string';

import './upgrade.scss';

class UpgradeButton extends React.Component {
  handleClick(location, e) {
    e.preventDefault();
    const query = queryString.stringify({ modal: location });
    browserHistory.replace(`${this.props.location.pathname}?${query}`);
  }

  render() {
    return (
      <div className="upgrade-btn">
        <a href="#" onClick={this.handleClick.bind(this, 'upgrade')}>Upgrade now</a>
      </div>
    );
  }
}

export default withRouter(UpgradeButton);
